import { apiGetProducerIntentDashboard } from '../../api/producerIntent';

const ALL_CROPS = 'All crops';

export default {
  namespaced: true,

  state: () => ({
    dashboard: null,
    cropFilter: ALL_CROPS,
    selectedSignalId: null,
    selectedLeadId: null,
    loading: false,
  }),

  getters: {
    metrics(state) {
      return state.dashboard?.metrics || [];
    },
    signals(state) {
      return state.dashboard?.signals || [];
    },
    leads(state) {
      return state.dashboard?.leads || [];
    },
    questions(state) {
      return state.dashboard?.questions || [];
    },
    regions(state) {
      return state.dashboard?.regions || [];
    },
    cropOptions(state) {
      return state.dashboard?.crop_filters || [ALL_CROPS];
    },
    selectedSignal(state, getters) {
      const list = getters.signals;
      return list.find((s) => s.id === state.selectedSignalId) || list[0] || null;
    },
    selectedLead(state, getters) {
      const list = getters.leads;
      return list.find((l) => l.id === state.selectedLeadId) || list[0] || null;
    },
    advisorReadyCount(state) {
      const tile = (state.dashboard?.metrics || []).find((m) => m.key === 'advisor_ready_leads');
      return tile?.value || '0';
    },
  },

  mutations: {
    setDashboard(state, payload) {
      state.dashboard = payload || null;
    },
    setCropFilter(state, value) {
      state.cropFilter = value || ALL_CROPS;
    },
    setSelectedSignal(state, id) {
      state.selectedSignalId = id;
    },
    setSelectedLead(state, id) {
      state.selectedLeadId = id;
    },
    setLoading(state, value) {
      state.loading = Boolean(value);
    },
  },

  actions: {
    async loadDashboard({ commit, state }) {
      commit('setLoading', true);
      try {
        const payload = await apiGetProducerIntentDashboard({ crop: state.cropFilter });
        commit('setDashboard', payload);
      } finally {
        commit('setLoading', false);
      }
    },

    async applyCropFilter({ commit, dispatch }, crop) {
      commit('setCropFilter', crop);
      await dispatch('loadDashboard');
    },

    selectSignal({ commit }, id) {
      commit('setSelectedSignal', id);
    },

    selectLead({ commit }, id) {
      commit('setSelectedLead', id);
    },
  },
};
